import * as api from '../../api';
import { router } from '../../router/index';

const pointEx = {
  state: {
    pointsExInfos: [],
    mapPointInfos: [],
    pointExTreeNode: [],
    pointExLegendData: [],
    avgPointExLegendData: [],
    trendLegendData: ['2018-10-27 23:00:00', '2018-10-27 23:10:00', '2018-10-27 23:20:00'],
    pointExChartData: {},
    avgPointExChartData: {},
    pointExHisChartData: {},
    pointExHisChartData4PointId: { 'dx': [], 'dy': [], 'dz': [], 'dr': [], 'epoch': [] },
    pointExHisTableData4PointId: [],
    pointExHisLegendData4PointId: ['103001'],
    pointExHisTableColumn4PointId: [
      {
        title: 'pointId',
        key: 'pointId'
      },
      {
        title: 'epoch',
        key: 'epoch'
      },
      {
        title: 'value',
        key: 'value'
      }
    ],
    sectionData: [],
    sectionDataHis: [],
    sectionColumns: [],
    sectionHisColumns: [
      {
        title: 'Section',
        key: 'sectionname'
      },
      {
        title: 'Crown',
        key: 'col1'
      },
      {
        title: '2018-10-27 23:00:00-dx',
        key: 'data1'
      },
      {
        title: '2018-10-27 23:10:00-dx',
        key: 'data2'
      },
      {
        title: '2018-10-27 23:20:00-dx',
        key: 'data3'
      }
    ],
    sectionPoints: {},
    lastestEpoch: '',
    sectionInfos: [] //截面信息
  },
  mutations: {
    //项目数据
    getPointsExInfos(state, data) {

      state.pointsExInfos = data;
    },
    getMapPointInfos(state, data) {
      state.mapPointInfos = [];
      for (var i = 0; i < data.length; i++) {
        var pointsExInfo = data[i];
        var position = {
          lng: pointsExInfo.longitude,
          lat: pointsExInfo.latitude,
          type: 'sensor',
          id: pointsExInfo.pointId
        }
        state.mapPointInfos.push(position)
      }
    },
    //采集器树
    getPointExTreeNode(state, data) {
      state.pointExTreeNode = [];
      for (var i = 0; i < data.length; i++) {
        var pointExInfo = data[i];
        var treeNode = {
          id: pointExInfo.pointId,
          title: pointExInfo.name,
          nodetype: 'collector',
          status: pointExInfo.sensorStatus,
          expand: false,
          children: []
        }
        state.pointExTreeNode.push(treeNode)
      }
    },
    getPointExChartData(state, data) {
      state.pointExChartData = data;
    },
    getAvgPointExChartData(state, data) {
      state.avgPointExChartData = data;
    },
    getPointExLegendData(state, data) {
      state.pointExLegendData = data;
    },
    getAvgPointExLegendData(state, data) {
      state.avgPointExLegendData = data;
    },
    getPointExHisChartData(state, data) {
      state.pointExHisChartData = data;
    },
    getSectionData(state, data) {
      state.sectionData = data;
    },
    getSectionDataHis(state, data) {

      state.sectionDataHis = data;
    },
    getPointExHisChartData4PointId(state, data) {
      state.pointExHisChartData4PointId = { 'dx': [], 'dy': [], 'dz': [], 'dr': [], 'epoch': [] };

      data.forEach(function (val, index) {
        state.pointExHisChartData4PointId['dx'].push([val.epoch, val.dx]);
        state.pointExHisChartData4PointId['dy'].push([val.epoch, val.dy]);
        state.pointExHisChartData4PointId['dz'].push([val.epoch, val.dz]);
        state.pointExHisChartData4PointId['dr'].push([val.epoch, val.dr]);
        state.pointExHisChartData4PointId['epoch'].push(val.epoch);
      });
    },
    getSectionColumns(state, data) {
      state.sectionColumns = data;
    },
    getPointExHisTableData4PointId(state, data) {
      state.pointExHisTableData4PointId = data;
    },
    getSectionPoints(state, data) {
      state.sectionPoints = data;
    },
    getLastestEpoch(state, data) {

      state.lastestEpoch = data;
    },
    getSectionInfos(state, data) {
      state.sectionInfos = data;
    }
  },
  getters: {
    getPointsExInfos(state) {

      return state.pointsExInfos;
    },
    getMapPointInfos(state) {

      return state.mapPointInfos;
    },
    getPointExTreeNode(state) {
      return state.pointExTreeNode;
    },
    getPointExLegendData(state) {
      return state.pointExLegendData;
    },
    getAvgPointExLegendData(state) {
      return state.avgPointExLegendData;
    },
    getPointExHisLegendData(state) {
      return state.trendLegendData;
    },
    getPointExChartData(state) {
      return state.pointExChartData;
    },
    getAvgPointExChartData(state) {
      return state.avgPointExChartData;
    },
    getPointHisExChartData(state) {
      return state.pointExHisChartData;
    },
    getSectionData(state) {
      return state.sectionData;
    },
    getSectionDataHis(state) {
      return state.sectionDataHis;
    },
    getSectionColumns(state) {
      return state.sectionColumns;
    },
    getSectionHisColumns(state) {
      return state.sectionHisColumns;
    },
    getPointExHisChartData4PointId(state) {

      return state.pointExHisChartData4PointId;
    },
    getPointExHisLegendData4PointId(state) {
      return state.pointExHisLegendData4PointId
    },
    getPointExHisTableData4PointId(state) {
      return state.pointExHisTableData4PointId
    },
    getPointExHisTableColumn4PointId(state) {
      return state.pointExHisTableColumn4PointId;
    },
    getSectionPoints(state) {
      return state.sectionPoints
    },
    getLastestEpoch(state) {
      return state.lastestEpoch;
    },
    getSectionInfos(state) {
      return state.sectionInfos;
    }
  },
  actions: {
    getPointsExInfosAction({ commit }, projectId) {
      api.getPointsExInfosResource(projectId).then(function (response) {
        commit("getPointsExInfos", response.body);
        commit("getMapPointInfos", response.body);
        commit("getPointExTreeNode", response.body);
      }, function (response) {
        console.log("==error==", response);
      });
    },
    getPointDataExInfosAction({ commit }, params) {
      api.getPointExDataInfosResource(params.projectId, params.index, params.epoch, params.num).then(function (response) {
        commit("getPointExChartData", response.body.data);
        commit("getPointExLegendData", response.body.legend);
        commit("getSectionInfos", response.body.sections);
      }, function (response) {
        console.log("==error==", response);
      });
    },

    getAvgPointDataExInfosAction({ commit }, params) {
      api.getAvgPointExDataInfosResource(params.projectId, params.index, params.epoch).then(function (response) {
        commit("getAvgPointExChartData", response.body.data);
        commit("getAvgPointExLegendData", response.body.legend);
      }, function (response) {
        console.log("==error==", response);
      });
    },

    getPointDataExInfosActionNo({ commit }, params) {
      api.getPointExDataInfosResource(params.projectId, params.index, params.epoch, params.num).then(function (response) {
        commit("getPointExChartData", response.body.data);
        //commit("getPointExLegendData", response.body.legend);
      }, function (response) {
        console.log("==error==", response);
      });
    },

    getAvgPointDataExInfosActionNo({ commit }, params) {
      api.getAvgPointExDataInfosResource(params.projectId, params.index, params.epoch).then(function (response) {
        commit("getAvgPointExChartData", response.body.data);
        //commit("getPointExLegendData", response.body.legend);
      }, function (response) {
        console.log("==error==", response);
      });
    },

    getSectionDataInfosAction({ commit }, params) {
      api.getSectionDataInfosResource(params.projectId, params.epoch, params.num).then(function (response) {
        commit("getSectionData", response.body);
      }, function (response) {
        console.log("==error==", response);
      });
    },
    getSectionDataHisInfosAction({ commit }, params) {
      api.getSectionDataHisInfosResource(params.projectId, params.epoch).then(function (response) {
        commit("getSectionDataHis", response.body);
      }, function (response) {
        console.log("==error==", response);
      });
    },
    getPointDataExHisInfosAction({ commit }, params) {
      api.getPointExDataHisInfosResource(params.projectId, params.positionId, params.index, params.epoch).then(function (response) {
        commit("getPointExHisChartData", response.body);
      }, function (response) {
        console.log("==error==", response);
      });
    },
    getPointDataExHisInfos4PointIdAction({ commit }, params) {
      api.getPointExDataHisInfos4PointResource(params.projectId, params.pointId, params.index).then(function (response) {
        commit("getPointExHisChartData4PointId", response.body);
        commit("getPointExHisTableData4PointId", response.body);
      }, function (response) {
        console.log("==error==", response);
      });
    },
    getPointExDataHisInfosByDateAction({ commit }, params) {
      api.getPointExDataHisInfosByDateResource(params.pointId, params.startDate, params.endDate).then(function (response) {
        commit("getPointExHisTableData4PointId", response.body);
        commit("getPointExHisChartData4PointId", response.body);
      }, function (response) {
        console.log("==error==", response);
      });
    },

    getSectionColumnsByDirtIdAction({ commit }, params) {
      api.getSectionColumnsByDirtIdResource(params.projectId, params.index).then(function (response) {
        commit("getSectionColumns", response.body);
      }, function (response) {
        console.log("==error==", response);
      });
    },

    getSectionPointsByPrjAction({ commit }, projectId) {
      api.getSectionPointsByPrjResource(projectId).then(function (response) {
        commit("getSectionPoints", response.body);
      }, function (response) {
        console.log("==error==", response);
      });
    },
    //getLastestEpochResource
    getLastestEpochAction({ commit }, projectId) {
      api.getLastestEpochResource(projectId).then(function (response) {
        commit("getLastestEpoch", response.body);
      }, function (response) {
        console.log("==error==", response);
      });
    },
  }
};

export default pointEx;



// WEBPACK FOOTER //
// ./src/store/modules/pointEx.js